import {getGroupQueryList} from "../module/role/js/ApiRole"

const cacheName = {
    department: 'department',//部门缓存
};

/**
 * 部门缓存
 * @param Callback 回调函数
 * @returns {any}
 */
export function getDepartment(Callback) {
    let obj = sessionStorage.getItem(cacheName.department);
    if (obj === null || obj.length < 1) {
        getGroupQueryList({}).then(res => {
            sessionStorage.setItem(cacheName.department, JSON.stringify(res.data.data));
            Callback(res.data.data)
        })
    } else {
        Callback(JSON.parse(obj))
    }
}
